import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useInput } from 'react-admin';
import { CountrySelector, usePhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

type Props = {
  source: string;
  label?: string;
  defaultCountry?: string;
  fullWidth?: boolean;
};

export default function MobileTelephoneInput({
  source,
  label = 'Mobile Telephone',
  defaultCountry = 'us',
  fullWidth = true,
}: Props): JSX.Element {
  const { field, fieldState, isRequired } = useInput({ source });
  const theme = useTheme();

  const phoneInput = usePhoneInput({
    defaultCountry,
    value: (field.value ?? '') as string,
    onChange: (data) => field.onChange((data.phone ?? '').trim()),
    forceDialCode: true,
  });

  const adornment = (
    <InputAdornment position='start' sx={{ mr: 0.5 }}>
      <CountrySelector
        selectedCountry={phoneInput.country.iso2}
        onSelect={(country) => phoneInput.setCountry(country.iso2)}
        renderButtonWrapper={({ children, rootProps }) => (
          <IconButton
            {...rootProps}
            size='small'

          >
            {children}
          </IconButton>
        )}
        dropdownStyleProps={{
          style: {
            backgroundColor: '#fff',
            color: '#111',
            zIndex: theme.zIndex.modal + 1,

          },
        }}

      />
      <Box sx={{
        height: 22, width: 1, mx: 0.75,
      }}
      />
    </InputAdornment>
  );

  return (
    <TextField
      label={label}
      required={isRequired}
      fullWidth={fullWidth}
      type='tel'
      value={phoneInput.inputValue}
      onChange={phoneInput.handlePhoneValueChange}
      inputRef={phoneInput.inputRef}
      onBlur={field.onBlur}
      error={!!fieldState.error}
      helperText={fieldState.error?.message || ' '}
      size='small'
      slotProps={{
        input: { startAdornment: adornment },

      }}

    />
  );
}
